export default "__VITE_ASSET__CLCjZaWd__"